import { twMerge } from "tailwind-merge";

interface ActiveStatusIconProps {
  isActive: boolean;
}

function ActiveStatusIcon({ isActive }: ActiveStatusIconProps) {
  return (
    <div
      className={twMerge(
        "h-3 w-3 rounded-full",
        isActive ? "bg-green-400" : "bg-red-500"
      )}
    />
  );
}

export default ActiveStatusIcon;
